import React from "react";
import { getIsSuccess, getSuccessMessage, hideSuccess, 
  getIsError, getErrorMessage, hideError } from "./notificationsSlice";

import { useSelector, useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";

import Snackbar from "@mui/material/Snackbar";
import Stack from "@mui/material/Stack";
import MuiAlert from "@mui/material/Alert";
import Slide from "@mui/material/Slide";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function Notifications() {

  const dispatch = useDispatch();
  const location = useLocation();
  const isSuccess = useSelector(getIsSuccess);
  const successMessage = useSelector(getSuccessMessage)
  const isError = useSelector(getIsError);
  const errorMessage = useSelector(getErrorMessage)

  function handleSuccessClose() {
    dispatch(hideSuccess());
  }
  
  function handleErrorClose() {
    dispatch(hideError());
  }

  // Field Admin has a 69px fixed bottom nav and the Snackbar sits at z-index 1400, so a
  // toast would otherwise cover the tab bar. Scoped to Field Admin: no other app in this
  // bundle has a bottom nav to clear.
  // The offset is repeated inside the media query because MUI's own
  // .MuiSnackbar-anchorOriginBottomLeft sets bottom:24px within @media (min-width:600px),
  // which outranks a plain sx rule of equal specificity.
  const bottomOffset = location.pathname.startsWith("/field-admin")
    ? { bottom: "84px", "@media (min-width:600px)": { bottom: "84px" } }
    : {};

  return (
    <>
      <Stack spacing={2} sx={{ width: "100%" }}>
        <Snackbar open={isSuccess} anchorOrigin={{ vertical: "bottom", horizontal: "left" }} sx={bottomOffset} autoHideDuration={4000} TransitionComponent={Transition} onClose={handleSuccessClose}>
          <Alert onClose={handleSuccessClose} severity="success" sx={{ width: "100%" }}>
            {successMessage}
          </Alert>
        </Snackbar>
        <Snackbar open={isError} anchorOrigin={{ vertical: "bottom", horizontal: "left" }} sx={bottomOffset} autoHideDuration={4000} TransitionComponent={Transition} onClose={handleErrorClose}>
          <Alert onClose={handleErrorClose} severity="error" sx={{ width: "100%" }}>
            {errorMessage}
          </Alert>
        </Snackbar>
      </Stack>
    </>
  );
};